module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-vial.36f9b58c.svg";